import { render, staticRenderFns } from "./ManualParamList.vue?vue&type=template&id=59a36e78"
import script from "./ManualParamList.vue?vue&type=script&lang=js"
export * from "./ManualParamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports